var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGe = function SvgIconGe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.898 10.435H13.565V.102a12.1 12.1 0 0 0-3.13 0v10.333H.102a12.1 12.1 0 0 0 0 3.13h10.333v10.333a12.1 12.1 0 0 0 3.13 0V13.565h10.333a12.1 12.1 0 0 0 0-3.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.304 5.74V4.175H5.74V5.74H4.174v1.565h1.565V8.87h1.565V7.305H8.87V5.74zM18.261 5.74V4.175h-1.565V5.74h-1.565v1.565h1.565V8.87h1.565V7.305h1.566V5.74zM7.304 16.697V15.13H5.74v1.566H4.174v1.565h1.565v1.565h1.565v-1.565H8.87v-1.565zM18.261 16.697V15.13h-1.565v1.566h-1.565v1.565h1.565v1.565h1.565v-1.565h1.566v-1.565z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconGe;